import React from 'react'
import { Table } from 'react-bootstrap'

import useTranslation from '@/Hooks/UseTranslation'
import { MsProjectPreview } from '@/Services/MsProjectImportService'
import { RelationSummaryText } from '@/Components/ProgrammationManager/Sections/Relations/RelationSummaryItem'
import TaskImportSourceViewer from '@/Components/TaskImportSourceViewer/TaskImportSourceViewer'

type Props = {
  relations: MsProjectPreview['relations']
  onGoToProgrammingRow: (uid: string) => void
}

const RelationsTab = ({ relations, onGoToProgrammingRow }: Props) => {
  const { t } = useTranslation()

  if (!relations.length) return <div className="text-muted py-3">{t('MS_PROJECT_IMPORTER:NoRelations')}</div>

  return (
    <>
      <h5>{t('MS_PROJECT_IMPORTER:RelationsPreview')}</h5>
      <Table bordered hover size="sm" responsive className="ms-project-importer-relations">
        <thead><tr><th>{t('MS_PROJECT_IMPORTER:Description')}</th><th>{t('TASK_IMPORT_SOURCE:Column')}</th></tr></thead>
        <tbody>{relations.map((relation, index) => (
          <tr key={`${relation.fromUid}-${relation.toUid}-${index}`}>
            <td>
              <RelationSummaryText
                type={relation.type}
                originName={relation.fromName || relation.fromId}
                destinationName={relation.toName || relation.toId}
                originContent={<button type="button" className="ms-project-importer-task-link" onClick={() => onGoToProgrammingRow(relation.fromUid)}>{relation.fromName || relation.fromId}</button>}
                destinationContent={<button type="button" className="ms-project-importer-task-link" onClick={() => onGoToProgrammingRow(relation.toUid)}>{relation.toName || relation.toId}</button>}
                lag={relation.lag}
              />
            </td>
            <td><TaskImportSourceViewer source={relation.importSource} taskName={`${relation.fromName || relation.fromId} - ${relation.toName || relation.toId}`} recordLabelKey="TASK_IMPORT_SOURCE:Relation" compact /></td>
          </tr>
        ))}</tbody>
      </Table>
    </>
  )
}

export default RelationsTab
